import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { Currency, Rate } from '@iw/core/entities';

export interface DictionariesApi {
  getCurrencies(): Observable<Currency[]>;
  getRates(): Observable<Rate[]>;
}

export const DICTIONARIES_API = new InjectionToken<DictionariesApi>(
  'DICTIONARIES_API',
);
